export async function wait(duration: number, rejectPromise = false): Promise<void> {
    return new Promise((resolve, reject) => {
        setTimeout(() => (rejectPromise ? reject() : resolve()), duration);
    });
}
